export enum NewPaymentMethod {
  CREDIT_CARD,
  BANK_ACCOUNT,
  SAVED_PAYMENT,
  EMPTY_WALLET,
}
